import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React from 'react';

export function HighLowDropdown(props) {
    const { state, setState, label } = props
    const handleChange = (event) => {
        setState({ ...state, priority: event.target.value });
       
    };
    const getStateValue=() => {
        if(label === "Priority")
         return state.priority 
    }

    return (
        <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={getStateValue()}
            sx={{ maxWidth: '70px' }}
            onChange={handleChange}
        >
            <MenuItem value={'high'}>High</MenuItem>
            <MenuItem value={'low'}>Low</MenuItem>
        </Select>)
} 
